/**
 * Wake-on-app-load list for the office app (wave 3). One knock per callable per app load, throttled by
 * the helper (10 min per browser), fired from AppContent once the user is signed in.
 *
 * WHY THIS IS A SHELL LIST, NOT PER-SCREEN: a knock only helps a call that happens LATER than the knock.
 * Each name below is called after the app has loaded (a first Cmd+K keystroke, a Drive folder / email /
 * Needs Attention / FSR report screen opened later, an approve click), so waking it at load means it is
 * warm by then. A call that fires at the moment its screen mounts gains nothing from a per-screen knock.
 *
 * LEFT OUT ON PURPOSE: fire-and-forget telemetry and housekeeping (logPerformanceMetric, logUsageEvent,
 * logError, shared_updateLastLogin, shared_saveGeocodeResult: nobody waits on them), the two scoped
 * search keys (already prefetched at start), driver_getMyVehicleEligibility (Navigation fires it on
 * every screen at mount, the same moment a knock would), and every callable in the pinned
 * unwoken-comparison group (test-utils/wakeScreenIntegrity.ts), e.g. fieldService_listGenerators.
 */
export const WAKE_APP_SHELL = {
  appShell: {
    enabled: true,
    callables: [
      'search_searchRestricted',
      'fieldService_approveFsrAndReviewTicket',
      'drive_listFolderContents',
      'getGmailStatus',
      'fieldService_needsAttention',
      'fieldService_getEquipmentReview',
      'fieldService_getTravelEstimate',
      // Form dropdown options (the generators list, ~1 MB): called by every FSR/form screen, and the call
      // measured waiting ~20 s on a cold instance once (CLIENT-63, 10-12). Woken at load so it is warm
      // by the time any form opens; re-knocked on resume by the helper.
      'forms_getDataSourceOptions',
      // FIELD-NAGS-1: asked before every NEW service report starts (the "finish your earlier reports first" check). Knocked
      // at load, not kept warm (Nick 10-19: smart knocking, no paid minInstances), so the check lands on a warm instance.
      'forms_getBlockingDrafts',
    ],
  },
} as const;
